import useSWR from "swr"

import { smithersDeviceService } from "@/services/smithers-device-service"
import type {
  SmithersBulkImportJobStatus,
  SmithersBulkImportJobStatusResponse,
} from "@/types/smithers-bulk-import"

export const SMITHERS_BULK_IMPORT_POLL_INTERVAL_MS = 2_500

const TERMINAL_STATUSES = new Set<SmithersBulkImportJobStatus>([
  "COMPLETED",
  "COMPLETED_WITH_ERRORS",
  "FAILED",
])

export function isSmithersBulkImportTerminal(status: SmithersBulkImportJobStatus): boolean {
  return TERMINAL_STATUSES.has(status)
}

export function getSmithersBulkImportRefreshInterval(
  latestJob?: SmithersBulkImportJobStatusResponse,
): number {
  return latestJob && isSmithersBulkImportTerminal(latestJob.status)
    ? 0
    : SMITHERS_BULK_IMPORT_POLL_INTERVAL_MS
}

export function useSmithersBulkImportJob(jobId: string | null) {
  return useSWR(
    jobId ? ["smithers", "bulk-import", jobId] : null,
    () => smithersDeviceService.getBulkImportJob(jobId as string),
    {
      refreshInterval: getSmithersBulkImportRefreshInterval,
      errorRetryInterval: SMITHERS_BULK_IMPORT_POLL_INTERVAL_MS,
      revalidateOnFocus: false,
    },
  )
}
